import Vue from 'vue'
import getInitialDay from 'www/modules/Schedule/classes/ScheduleData/functions/renderData/helpers/getInitialDay'
import AppointmentButtonCallLpu from 'www/vue_components/common/AppointmentButtonCallLpu/AppointmentButtonCallLpu.vue'

/**
 * @description
 * Возвращает объект Map, который используется дальше для рендера календарей(календари для записи на услугу).
 * Функция возвращает список, который состоит из множества объектов рендера, или же только из одного.
 * При спецразмещении может быть несколько дубликатов карточек клиник. Сопоставление переменной 'isSingleRender' точно сообщает - в каком контейнере произошло изменение.
 * Если при клике передан parentCard и не найдено сопоставление - будет ошибка, которая ловится в вызывающем модуле.
 *
 * @param {object} opts -
 * @param {object} opts.data - собранные данные со страницы - интерфейс 'getModuleDataInterface'
 * @param { HTMLElement } opts.parentCard - карточка в списке, в которой необходимо заменить расписание
 * @param {Array<object>} opts.response - ответ на запрос
 * @param {string} opts.dataItem - data атрибут родителя
 *
 * @returns { Map } - данные для рендера списка календарей
 */

const getRenderServicesData = opts => {
  const {
    data,
    response,
    dataItem,
    parentCard,
  } = opts
  const resultData = new Map()

  data.items.forEach((pageData, scheduleContainer) => {
    const {
      lpuId,
      lpuPhone,
      coverNode,
      serviceIsDirect,
      serviceIsExpress,
      isEnabledLpuClub,
      lpuWorkingText,
    } = pageData
    const scheduleData = response.find(({ lpu_id: idResult }) => idResult === lpuId)
    const isListRender = !parentCard // рендер списка календарей
    const isSingleRender = parentCard === coverNode // рендер только 1 календаря

    if (!scheduleData) {
      renderCallButton({
        lpuPhone,
        lpuWorkingText,
        serviceIsExpress,
        scheduleContainer,
      })

      return
    }

    if (!(isListRender || isSingleRender)) {
      renderCallButton({
        lpuPhone,
        lpuWorkingText,
        serviceIsExpress,
        scheduleContainer,
      })

      return
    }

    const { slots, service_id: synonymId } = scheduleData
    const days = Object.keys(slots)
    const daysWithSlots = days.filter(date => slots[date].length)
    const isEmptySlotList = !daysWithSlots.length
    const {
      dtypeId,
    } = pageData.synonymPreview

    if (isEmptySlotList) {
      renderCallButton({
        lpuPhone,
        lpuWorkingText,
        serviceIsExpress,
        scheduleContainer,
      })

      return
    }

    const initDay = getInitialDay({
      daysWithSlots,
      currentSlots: slots,
    })

    let appointmentType = ''
    const useResponseAppointmentType = isSingleRender

    try {
      if (useResponseAppointmentType) {
        appointmentType = parentCard
          .querySelector('[data-appointment-type]')
          .getAttribute('data-appointment-type') // ToDo schedule-important избавиться от привязки к DOM дереву
      }
    } catch { /* Empty */ }

    resultData.set(scheduleContainer, {
      days,
      slots,
      lpuId,
      dtypeId,
      initDay,
      dataItem,
      lpuPhone,
      synonymId,
      data: slots,
      options: slots,
      lpuWorkingText,
      serviceIsDirect: useResponseAppointmentType
        ? appointmentType === 'direct'
        : serviceIsDirect,
      serviceIsExpress: useResponseAppointmentType
        ? appointmentType === 'express'
        : serviceIsExpress,
      isEnabledLpuClub,
      serviceData: opts.serviceData || pageData.synonymPreview.serviceData,
      useRedirect: true,
      isAppointmentLpu: true,
    })
  })

  return resultData
}

function renderCallButton(opts) {
  const {
    lpuPhone,
    lpuWorkingText,
    serviceIsExpress,
    scheduleContainer,
  } = opts

  if (
    window.MOBILE_VERSION
    && serviceIsExpress
    && lpuPhone
  ) {
    scheduleContainer.innerHTML = '<div class="schedule-button"></div>'

    new Vue({
      el: scheduleContainer.querySelector('.schedule-button'),
      render: h => h(AppointmentButtonCallLpu, {
        props: {
          phone: lpuPhone,
          lpuWorkingText,
        },
      }),
    })
  }
}

export default getRenderServicesData
